"use client";

import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "~/utils/fontsConfig";
import { FaRegCircle } from "react-icons/fa";

interface RadioGroupItemProps
    extends React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> {
    showIndicatorIcon?: boolean;
}

const RadioGroup = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Root
            className={cn("grid gap-2", className)}
            {...props}
            ref={ref}
        />
    );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    RadioGroupItemProps
>(({ className, showIndicatorIcon = true, children, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Item
            ref={ref}
            className={cn(
                " aspect-square h-4 w-4 rounded-full border-2 border-transparent p-[0.3rem] text-primary transition-colors duration-200",
                "data-[state=checked]:h-[1.8rem] data-[state=checked]:w-[1.8rem] data-[state=checked]:scale-110 data-[state=checked]:border-white data-[state=checked]:shadow-[inset_0_0_0_4px_black]",
                className,
            )}
            {...props}
        >
            {children}
            <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                {showIndicatorIcon && (
                    <FaRegCircle className="h-2.5 w-2.5 fill-current text-current" />
                )}
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
